export const getValueUnit = (valueUnit?: any): { value: string; unit: string } => {
    if (typeof valueUnit === "string") {
        const split = valueUnit.match(/^(\d+)(.*)$/);
        if (split) {
            return { value: split[1], unit: split[2] };
        }
    }
    return { value: "", unit: "px" };
};
